import { render, staticRenderFns } from "./BBcode.vue?vue&type=template&id=34aed788&"
import script from "./BBcode.vue?vue&type=script&lang=js&"
export * from "./BBcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports